<script setup lang="ts">
import { useDisciplineScheduleStore } from '../model/schedule/store'
import DisciplineScheduleDay from './DisciplineScheduleDay.vue'
import DisciplineScheduleSlot from './DisciplineScheduleSlot.vue'

defineOptions({
  name: 'DisciplineScheduleGrid',
})

const store = useDisciplineScheduleStore()
</script>

<template>
  <div class="discipline-schedule-grid">
    <div
      v-for="column in store.getGrid"
      :key="column.day"
      class="discipline-schedule-grid__column"
    >
      <DisciplineScheduleDay
        :day="column.day"
        :slots="column.slots"
      />
      <DisciplineScheduleSlot
        v-for="slot in column.slots"
        :key="`${slot.day}-${slot.start_time}`"
        :schedule-slot="slot"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineScheduleGrid.scss" />
